<ion-content class="ion-padding">
  <div class="loading-wrapper">
    <ion-card class="loading-card" *ngIf="state === 'loading'">
      <ion-spinner name="crescent"></ion-spinner>
      <ion-label>Loading, please wait...</ion-label>
    </ion-card>

    <ion-card class="loading-card error" *ngIf="state === 'failed'">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <ion-label>Something went wrong!</ion-label>
      <ion-button expand="block" color="danger" (click)="goToLogin()">Go to Login</ion-button>
    </ion-card>

    <ion-card class="loading-card success" *ngIf="state === 'success'">
      <ion-icon name="checkmark-circle-outline"></ion-icon>
      <ion-label>Success! Redirecting...</ion-label>
    </ion-card>
  </div>
</ion-content>